<div data-gazetteer-wrapper class="explore-map__gazetteer">
  <label class="sr-only" for="gazetteerSearch">Gazetteer Search</label>
  <div class="input-group shadow">
    <input
      type="text"
      id="gazetteerSearch"
      autocomplete="off"
      spellcheck="false"
      (click)="showResultsList()"
      [(ngModel)]="searchTerm"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onFieldChange($event)"
      class="form-control border-0"
    />
    <button type="button" class="btn btn-secondary btn-icon-only" (click)="resetSearch()">
      <i class="bi bi-search" aria-label="Search" *ngIf="!searchTerm.trim().length"></i>
      <i class="bi bi-x-lg" aria-label="Clear Search" *ngIf="searchTerm.trim().length > 0"></i>
    </button>
  </div>
  <ul
    class="list-unstyled gazetteer-list"
    [ngClass]="resultsClass"
    *ngIf="searchResults && searchResults.results.length; else noResults"
  >
    <li *ngFor="let result of searchResults.results">
      <button
        class="btn btn-block gazetteer-result__button"
        type="button"
        (click)="selectSearchResult(result)"
      >
        <span [innerHTML]="result.name | highlight: searchTerm"></span>
        <span class="country"
          ><span *ngIf="result.region_name">{{ result.region_name }}, </span
          >{{ result.country_name }}</span
        >
      </button>
    </li>
  </ul>

  <ng-template #noResults>
    <ul class="list-unstyled gazetteer-list" [ngClass]="resultsClass">
      <li *ngIf="!searching && searchTerm.length">
        <span class="no-results">No search results found</span>
      </li>
      <li *ngIf="searching && searchTerm.length">
        <div
          class="loading-spinner d-flex align-items-center justify-content-center alert mb-0"
          role="alert"
        >
          <div class="spinner-border" role="status"></div>
        </div>
      </li>
    </ul>
  </ng-template>
</div>
